(() => {
  const root = document.querySelector('[data-gp-collection]');
  if (!root) return;
  const sectionId = root.dataset.section;
  const lock = (on) => document.body.classList.toggle('gp-lock', on);

  function bindFilters(scope) {
    const panel = scope.querySelector('[data-filters]');
    const openBtn = scope.querySelector('[data-open-filters]');
    const form = scope.querySelector('[data-filter-form]');
    if (openBtn && panel) {
      openBtn.addEventListener('click', () => {
        panel.classList.add('is-open'); openBtn.setAttribute('aria-expanded', 'true'); lock(true);
        const first = panel.querySelector('input, button'); if (first) first.focus();
      });
      panel.querySelectorAll('[data-close-filters]').forEach((b) => b.addEventListener('click', () => {
        panel.classList.remove('is-open'); openBtn.setAttribute('aria-expanded', 'false'); lock(false); openBtn.focus();
      }));
    }
    if (form) {
      let timer;
      form.addEventListener('change', () => { clearTimeout(timer); timer = setTimeout(() => apply(formUrl(form)), 250); });
      form.addEventListener('submit', (e) => { e.preventDefault(); apply(formUrl(form)); });
    }
    const sort = scope.querySelector('[data-sort]');
    if (sort) sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value); url.searchParams.delete('page');
      apply(url.pathname + url.search);
    });
    scope.querySelectorAll('[data-remove], [data-clear]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); apply(a.getAttribute('href')); }));
    const more = scope.querySelector('[data-more]');
    if (more) more.addEventListener('click', (e) => { e.preventDefault(); loadMore(more.getAttribute('href')); });
  }

  const introMore = root.querySelector('[data-intro-more]');
  if (introMore) introMore.addEventListener('click', () => {
    const open = root.querySelector('[data-intro]').classList.toggle('is-open');
    introMore.setAttribute('aria-expanded', String(open)); introMore.textContent = open ? 'Less' : 'More';
  });

  const story = root.querySelector('[data-story-toggle]');
  if (story) story.addEventListener('click', () => {
    const open = story.closest('.gp-coll__story').classList.toggle('is-open');
    story.setAttribute('aria-expanded', String(open)); story.textContent = open ? 'Read less' : 'Read more';
  });

  function formUrl(form) {
    const params = new URLSearchParams(new FormData(form));
    [...params.keys()].forEach((k) => { if (params.get(k) === '') params.delete(k); });
    return `${window.location.pathname}?${params.toString()}`;
  }

  async function fetchSection(url) {
    const u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    const res = await fetch(u.toString());
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    return doc.querySelector('[data-gp-collection]');
  }

  async function apply(url) {
    const grid = root.querySelector('[data-grid]');
    if (grid) grid.classList.add('is-loading');
    const wasOpen = root.querySelector('[data-filters].is-open');
    try {
      const fresh = await fetchSection(url);
      if (!fresh) { window.location.href = url; return; }
      ['.gp-coll__bar', '.gp-coll__layout'].forEach((sel) => {
        const a = root.querySelector(sel), b = fresh.querySelector(sel);
        if (a && b) a.replaceWith(b);
      });
      if (wasOpen) {
        const panel = root.querySelector('[data-filters]'); if (panel) panel.classList.add('is-open');
        const btn = root.querySelector('[data-open-filters]'); if (btn) btn.setAttribute('aria-expanded', 'true');
      }
      window.history.replaceState({}, '', url);
      bindFilters(root);
    } catch {
      window.location.href = url;
    }
  }

  async function loadMore(url) {
    const wrap = root.querySelector('[data-more-wrap]');
    const btn = wrap.querySelector('[data-more]');
    btn.textContent = 'Loading…';
    try {
      const fresh = await fetchSection(url);
      const cards = fresh.querySelectorAll('[data-grid] > *');
      const grid = root.querySelector('[data-grid]');
      cards.forEach((c) => grid.appendChild(c));
      const nextWrap = fresh.querySelector('[data-more-wrap]');
      if (nextWrap) { wrap.replaceWith(nextWrap); bindMore(); } else { wrap.remove(); }
    } catch {
      window.location.href = url;
    }
  }

  function bindMore() {
    const more = root.querySelector('[data-more]');
    if (more) more.addEventListener('click', (e) => { e.preventDefault(); loadMore(more.getAttribute('href')); });
  }

  bindFilters(root);
})();

(() => {
  const v = document.querySelector('.gp-y27p__film');
  if (!v) return;
  const btn = document.querySelector('[data-film-toggle]');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (window.matchMedia('(max-width: 749px)').matches) {
    v.poster = v.dataset.posterMobile;
    v.querySelector('source').src = v.dataset.srcMobile;
    v.load();
  }
  const sync = () => { btn.classList.toggle('is-paused', v.paused); btn.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video'); };
  if (reduce) v.pause(); else { const p = v.play(); if (p) p.catch(() => {}); }
  v.addEventListener('play', sync); v.addEventListener('pause', sync); sync();
  btn.addEventListener('click', () => { if (v.paused) v.play(); else v.pause(); });
})();

(() => {
  const bar = document.querySelector('[data-cats]');
  if (!bar) return;
  const count = document.querySelector('[data-count]');
  const baseCount = count ? count.textContent : '';
  const apply = (cat) => {
    bar.querySelectorAll('[data-cat-btn]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.catBtn === cat)));
    const cards = document.querySelectorAll('[data-grid] .gp-card');
    let shown = 0;
    cards.forEach((c) => { const on = !cat || c.dataset.cat === cat; c.classList.toggle('is-off', !on); if (on) shown += 1; });
    if (count) count.textContent = cat ? `${shown} ${shown === 1 ? 'product' : 'products'}` : baseCount;
    const url = new URL(location.href);
    if (cat) url.searchParams.set('type', cat); else url.searchParams.delete('type');
    history.replaceState(null, '', url);
  };
  bar.addEventListener('click', (e) => { const b = e.target.closest('[data-cat-btn]'); if (b) apply(b.dataset.catBtn); });
  const alias = { jackets: 'outerwear', bottoms: 'shorts' };
  let start = new URL(location.href).searchParams.get('type');
  if (start && alias[start]) start = alias[start];
  if (start && bar.querySelector(`[data-cat-btn="${start}"]`)) apply(start);
})();

(() => {
  // Chip rows scroll sideways on phones: bring the selected chip into view (row only, never the page).
  const show = (row) => {
    const sel = row && row.querySelector('[aria-current="page"], [aria-pressed="true"]');
    if (!sel || row.scrollWidth <= row.clientWidth) return;
    const r = row.getBoundingClientRect(), s = sel.getBoundingClientRect();
    if (s.left < r.left || s.right > r.right) row.scrollLeft += s.left - r.left - (r.width - s.width) / 2;
  };
  document.querySelectorAll('.gp-coll__nav, .gp-coll__cats').forEach(show);
})();
